import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { ExperienceSchedulingService } from './experience-scheduling.service';
import { ExperienceSchedulingTab1Part } from './tabs/tab-1/experience-scheduling-tab-1.part';
import { ExperienceSchedulingTab2Part } from './tabs/tab-2/experience-scheduling-tab-2.part';
import { ExperienceSchedulingViewsPart } from './views/experience-scheduling-views.part';


@Component({
	selector: 'experience-scheduling-page',
	standalone: true,
	imports: [
		ExperienceSchedulingTab1Part, ExperienceSchedulingTab2Part, ExperienceSchedulingViewsPart,
		PageTab1Directive, PageTab2Directive, PageTab3Directive, TrimesterDroplistWidget,
		DroplistWidget, ToolbarWidget,
		PageTabsWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './experience-scheduling.page.html',
})
export class ExperienceSchedulingPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;
	constructor(
		public pageService: ExperienceSchedulingService,
	) {
	}


	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}